import { css, styled, getTypography, selectTheme } from '@creditas-ui/react'

const boxWithShadow = ({ shadow }) =>
  shadow &&
  css`
    box-shadow: rgb(170 187 187 / 50%) 0px 8px 16px 0px;
  `

const boxWithBgWhite = ({ bgWhite }) =>
  bgWhite &&
  css`
    background-color: white;
  `

const Box = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 50%;
  border-radius: 5px;
  padding: 24px;
  ${boxWithBgWhite}

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media screen and (min-width: 980px) {
    border-radius: 20px;
    ${boxWithShadow}
    align-items: start;
    flex-direction: column;
    justify-content: space-between;
  }
`
const BoxImage = styled.div`
  width: calc(100% + 48px);
  overflow: hidden;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  margin-left: -24px;
  margin-top: -24px;

  img {
    display: block;
    width: 100%;
  }
`

const BoxIcon = styled.div`
  width: 32px;
`
const BoxText = styled.div``

const BoxTextTitle = styled.h4`
  font-style: normal;
  ${getTypography('bodyLgMedium')};
  color: ${selectTheme('colors.neutral.90')};
  margin-left: 10px;

  @media screen and (min-width: 980px) {
    margin-left: 0;
  }
`
const BoxTextDescription = styled.p`
  margin-top: 12px;
  font-style: normal;
  ${getTypography('bodySmRegular')};
  color: ${selectTheme('colors.neutral.60')};
`

export { Box, BoxImage, BoxIcon, BoxText, BoxTextTitle, BoxTextDescription }
